module.exports = "/_next/static/images/odontologicoProduto-e203541d93cb2b4a3ccdc620b7f5e61a.svg";